import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y2000 = new LunarYear(
  moment.tz('2000-02-05 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [30, 30, 29, 29, 30, 29, 29, 30, 29, 30, 30, 29],
)

export default Y2000
